
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MergingBOMDialog extends Serenity.EntityDialog<MergingBOMRow, any> {
        protected getFormKey() { return MergingBOMForm.formKey; }
        protected getIdProperty() { return MergingBOMRow.idProperty; }
        protected getLocalTextPrefix() { return MergingBOMRow.localTextPrefix; }
        protected getNameProperty() { return MergingBOMRow.nameProperty; }
        protected getService() { return MergingBOMService.baseUrl; }
        protected getDeletePermission() { return MergingBOMRow.deletePermission; }
        protected getInsertPermission() { return MergingBOMRow.insertPermission; }
        protected getUpdatePermission() { return MergingBOMRow.updatePermission; }

        protected form = new MergingBOMForm(this.idPrefix);

    }
}